import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('website_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      setEmail('');
      return;
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d9qab3ue3oq4jqumtj90', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const responseText = await response.text();
      let parsed: any;
      try { parsed = JSON.parse(responseText); } catch { parsed = {}; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        setStatus('error');
        setErrorMsg(serverMsg.includes('spam') ? '提交失败，请稍后再试' : (serverMsg || '订阅失败，请稍后再试'));
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请稍后再试');
    }
  };

  return (
    <section className="py-14 md:py-20 bg-background-900">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50">
          订阅最新<span className="text-accent-500">观影推荐</span>
        </h2>
        <p className="mt-3 text-sm md:text-base text-background-300 max-w-md mx-auto">
          每周获取最新欧美大片推荐和深度影评，不错过任何精彩内容
        </p>

        {status === 'success' ? (
          <div className="mt-6 inline-flex items-center gap-2 px-5 py-3 bg-accent-500/20 border border-accent-500/40 rounded-full text-accent-400 text-sm">
            <i className="ri-checkbox-circle-line"></i>
            订阅成功！感谢你的关注
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="mt-6 flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto" data-readdy-form="">
            <div className="honeypot-wrap">
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            </div>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入你的邮箱地址"
              required
              className="w-full sm:flex-1 px-4 py-3 bg-background-800 border border-background-600 rounded-full text-sm text-background-50 placeholder:text-background-400 focus:outline-none focus:border-accent-500 transition-colors duration-200"
            />
            <button
              type="submit"
              className="w-full sm:w-auto px-6 py-3 bg-accent-500 text-background-950 rounded-full font-medium text-sm hover:bg-accent-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              立即订阅
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="mt-3 text-sm text-red-400">{errorMsg}</p>
        )}
      </div>
    </section>
  );
}